import React, { Fragment } from 'react';
import { Link } from 'react-router-dom';
import { CardContent, Divider, Grid, ListItem, ListItemText } from '@mui/material';
import { PmiCard } from 'shell/components/shared/card';
import PmiTitle from 'shell/components/shared/title';
import { useUserProfile } from 'shell/hooks/use-user-profile';
import Breadcrumbs from 'shell/components/shared/breadcrumb';
import { CashManagementCrumbs } from 'front-office/constants/cash-management-crumbs';
import { useActionAuthorization } from 'shell/hooks/use-action-authorization';
import { PrintReceiptPosAuthorizations } from 'shell/authorizations/front-office';

const checkDesc = [
  {
    label: 'Controllo/chiusura mese precedente per servizio',
    path: '/sportello/gestione-cassa/mese-precedente',
  },
  {
    label: 'Controllo servizio/operatore/data',
    path: '/sportello/gestione-cassa/controllo-servizio',
  },
  {
    label: 'Stampa quindicinale CIE rilasciate',
    path: '/sportello/gestione-cassa/stampa-quindicinale',
  },
];

const cashOffice = [
  {
    label: 'Stampa controllo mese corrente per tutti i servizi',
    path: '/sportello/gestione-cassa/mese-corrente',
  },
  {
    label: 'Stampa chiusura di cassa mensile di tutti i servizi',
    path: '/sportello/gestione-cassa/chiusura-mensile',
  },
];

const Home = (): React.ReactElement => {
  const { userProfile } = useUserProfile();

  const actions = useActionAuthorization({
    stampaRicevutPos: PrintReceiptPosAuthorizations,
  });

  /**
   * Il menu UFFICIO CASSA deve essere visualizzato solo se l’operatore ha
   * Flag autorizzazione STAMPA CONTROLLO DI CASSA con valore 2 = autorizzato stampa per Servizio Operatore e Data
   */

  const showUfficioCassa = userProfile.datiLogin?.profile?.feature?.controlloDiCassa === '2';

  return (
    <Fragment>
      <Breadcrumbs items={CashManagementCrumbs} />
      <Grid container spacing={2} rowSpacing={3}>
        <PmiTitle title="Gestione Cassa" />
      </Grid>
      <Grid container spacing={2} rowSpacing={1}>
        <Grid item xs={12}>
          Controllo di cassa
        </Grid>
        <Grid item xs={12}>
          <Divider />
        </Grid>
        {checkDesc
          .filter((item) =>
            item.label === 'Controllo/chiusura mese precedente per servizio' ||
            item.label === 'Stampa quindicinale CIE rilasciate'
              ? userProfile.datiLogin?.profile?.feature?.controlloDiCassa === '2' ||
                userProfile.datiLogin?.profile?.feature?.controlloDiCassa === '1'
              : true
          )
          .map((entry) => (
            <Grid key={entry.label} item xs={12} md={4} lg={3}>
              <Link to={entry.path} className="pmi-anchor">
                <PmiCard style={{ height: '100%' }}>
                  <CardContent>
                    <ListItem>
                      <ListItemText primary={entry.label} />
                    </ListItem>
                  </CardContent>
                </PmiCard>
              </Link>
            </Grid>
          ))}
        {!actions.stampaRicevutPos ? undefined : (
          <Grid item xs={12} md={4} lg={3}>
            <Link to="/sportello/stampa-ricevuta-pos" className="pmi-anchor">
              <PmiCard style={{ height: '100%' }}>
                <CardContent>
                  <ListItem>
                    <ListItemText primary="Rilascio ricevuta POS" />
                  </ListItem>
                </CardContent>
              </PmiCard>
            </Link>
          </Grid>
        )}
        {showUfficioCassa ? (
          <>
            <Grid item marginTop={3} xs={12}>
              Menù ufficio cassa
            </Grid>
            <Grid item xs={12}>
              <Divider />
            </Grid>
            {cashOffice.map((entry) => (
              <Grid key={entry.label} item xs={12} md={4} lg={3}>
                <Link to={entry.path} className="pmi-anchor">
                  <PmiCard style={{ height: '100%' }}>
                    <CardContent>
                      <ListItem>
                        <ListItemText primary={entry.label} />
                      </ListItem>
                    </CardContent>
                  </PmiCard>
                </Link>
              </Grid>
            ))}
          </>
        ) : null}
      </Grid>
    </Fragment>
  );
};

Home.displayName = 'Gestione cassa navigation menu';

export default Home;
